import { api } from "@/APIRequests";

export async function sendWelcomeEmail({ patientId }: { patientId: string }): Promise<void> {
  return api.sharedTyped.send_on_demand_welcome_email({
    params: { showLoader: false },
    patientId,
  });
}
